/** Matches backend/utils/accountProfileFilters.js and Accounts card UI. */

const PLACEHOLDER_PROFILE_VALUES = new Set([
  'n/a',
  'na',
  'none',
  'null',
  '-',
  '—',
  'unknown',
  'not set',
  'notset'
]);

export function profileFieldMissing(value) {
  const s = String(value ?? '').trim().toLowerCase();
  if (!s) return true;
  return PLACEHOLDER_PROFILE_VALUES.has(s);
}

export function accountPhoneDisplay(account) {
  const pn = account?.phoneNumber;
  const xs = account?.xSettings?.phone;
  if (pn != null && String(pn).trim()) return String(pn).trim();
  if (xs != null && String(xs).trim()) return String(xs).trim();
  return '';
}

export function passesProfileFilter(account, filterProfile) {
  const fp = filterProfile && filterProfile !== 'all' ? filterProfile : 'all';
  if (fp === 'all') return true;
  const dobMissing = profileFieldMissing(account?.dateOfBirth);
  const phoneMissing = profileFieldMissing(accountPhoneDisplay(account));
  if (fp === 'missing_dob') return dobMissing;
  if (fp === 'missing_phone') return phoneMissing;
  if (fp === 'missing_both') return dobMissing && phoneMissing;
  if (fp === 'profile_updated') return account?.profileUpdateStatus === 'completed';
  if (fp === 'profile_partial') return account?.profileUpdateStatus === 'partial_failure' || account?.profileUpdateStatus === 'failed';
  if (fp === 'profile_never_updated') return !account?.profileUpdateStatus;
  return true;
}
